import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { X } from "lucide-react";

export function ImageUploadField({ formData, f, api, label = "Bild (optional)" }) {
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const data = new FormData();
    data.append("file", file);
    try {
      const res = await api.upload("/upload", data);
      if (res.data?.url) {
        f("image_url", res.data.url);
        toast.success("Bild hochgeladen");
      } else {
        toast.error("Upload fehlgeschlagen: Keine URL erhalten");
      }
    } catch (err) {
      const detail = err.response?.data?.detail || err.message || "Unbekannter Fehler";
      toast.error(`Fehler beim Hochladen: ${detail}`);
    }
  };

  return (
    <div>
      <Label className="text-sm">{label}</Label>
      {formData.image_url ? (
        <div className="mt-2 relative inline-block">
          <img src={formData.image_url} alt="" className="h-24 object-cover border border-white/10 rounded" />
          <button type="button" onClick={() => f("image_url", "")}
            className="absolute -top-2 -right-2 p-1 bg-destructive rounded-full" data-testid="remove-image-btn">
            <X className="w-3 h-3 text-white" />
          </button>
        </div>
      ) : (
        <input type="file" accept="image/*" onChange={handleImageUpload} data-testid="dialog-image-upload"
          className="mt-1 block w-full text-sm text-muted-foreground file:mr-3 file:py-1.5 file:px-3 file:border-0 file:bg-primary file:text-primary-foreground file:text-xs file:font-bold file:uppercase file:cursor-pointer" />
      )}
    </div>
  );
}
